import { Placeholder_Query } from "@/modules/crm/leads/graphql-queries/general-queries";
import { gql, useLazyQuery, useQuery } from "@apollo/client";

const UseGql = (defaultQuery, defaultParams = {}, clientName = "") => {
  // added placeholder query when defaultQuery is undefined
  let parsedQuery = defaultQuery ?? Placeholder_Query;

  // init params
  const params = {
    fetchPolicy: "no-cache",
  };
  // add variables to params if needed
  if (Object.keys(defaultParams)?.length) {
    params.variables = defaultParams;
  }

  const [getData, { data, loading, refetch }] = useLazyQuery(
    parsedQuery,
    params
  );

  // define executeQuery method
  // it will responsible to pass variables
  // when available
  const executeQuery = (variables = {}) => {
    if (Object.keys(variables)?.length) {
      return getData({ variables, context: { clientName } });
    } else {
      return getData({ context: { clientName } });
    }
  };

  return { loading, data, executeQuery, refetch };
};

export default UseGql;
